import { get } from "./base";

const getLastUpdated = () => {
  return get("last-updated");
};

export default {
  getLastUpdated,
};
